export type ScansDailyPoint = {
  day: string;
  runs: number;
  ok_runs: number;
  new_third_parties: number;
  new_cookie_names: number;
};

export async function fetchScansDaily(
  baseUrl: string,
  siteKey?: string,
  fromISO?: string,
  toISO?: string,
): Promise<ScansDailyPoint[]> {
  const url = new URL('/api/admin/scans/summary/daily', baseUrl);
  if (siteKey) url.searchParams.set('siteKey', siteKey);
  if (fromISO) url.searchParams.set('from', fromISO);
  if (toISO) url.searchParams.set('to', toISO);
  const r = await fetch(url.toString(), { credentials: 'include' });
  if (!r.ok) throw new Error(`scans daily failed: ${r.status}`);
  return r.json();
}
